import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IRemunerationFixed } from 'interfaces/RemunerationFixed';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
  IListRequestParams,
} from 'interfaces/requests';

import endpoints from './endpoints';
import { IRemunerationFixedListState } from './interfaces';

export const listRemunerationFixedAction = createAsyncThunk<
  IPaginatedListResponse<IRemunerationFixed>,
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listRemunerationFixed/fetch', async (payload, { rejectWithValue }) => {
  try {
    const result = await get<IPaginatedListResponse<IRemunerationFixed>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.listRemunerationsFixed(),
        params: payload,
      },
    );
    return {
      count: result.data.count,
      values: result.data.values.map((value) => ({ ...value, id: value._id })),
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState: IRemunerationFixedListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
  count: 0,
};

const remunerationFixedListSlice = createSlice({
  name: 'remunerationFixedList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listRemunerationFixedAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.list = action.payload.values;
      state.count = action.payload.count;
      return state;
    });
    builder.addCase(listRemunerationFixedAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(listRemunerationFixedAction.rejected, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || '';
      return state;
    });
  },
});

const { reducer } = remunerationFixedListSlice;
export default reducer;
